module.exports = __webpack_public_path__ + "assets/linkedin.d5bd0977.svg";